import React from 'react';
import moment from 'moment';
import { getRsvpDisplayModel, getTimeOfDaySuffix, isAllDayGuest } from '../utils/rsvpDisplay';

const venueTextStyle = {
    color: '#4D8495',
    margin: '20px 0',
    textAlign: 'center',
    width: '80%',
};

const finerTextStyle = {
    margin: '20px auto',
    textAlign: 'center',
    width: '80%',
};

const RsvpInvitationDetails = ({ wedding, weddingDate, invitedTo, giftRegistryMsg }) => {
    const display = getRsvpDisplayModel(wedding, invitedTo);
    const timeSuffix = display.startTime
        ? getTimeOfDaySuffix(display.startTime, display.isEveningGuest)
        : '';

    return (
        <>
            {display.combineDateAndTime ? (
                <p className="rsvp-subheader">
                    {moment(weddingDate).format('dddd Do MMMM YYYY')}
                    {display.startTime ? ` · ${display.startTime}` : ''}
                </p>
            ) : (
                <>
                    <p className="rsvp-subheader">{moment(weddingDate).format('dddd Do MMMM YYYY')}</p>
                    {display.startTime && (
                        <p>
                            {display.startTime} {timeSuffix}
                        </p>
                    )}
                </>
            )}

            {display.heroVenueText && (
                <p style={venueTextStyle}>{display.heroVenueText}</p>
            )}

            {display.showReceptionToFollow && (
                <p className="rsvp-subheader-black">Reception to follow</p>
            )}

            <div className="rsvp-line-break"></div>

            <div>
                <h2 className="rsvp-blue-header">The finer details</h2>
                {display.showReceptionInFinerDetails && (
                    <>
                        <h4 className="rsvp-subheader">Reception venue</h4>
                        <p style={finerTextStyle}>{display.finerDetailsReceptionText}</p>
                    </>
                )}
                <h4 className="rsvp-subheader">Dress code</h4>
                <p style={finerTextStyle}>{wedding?.dressCode}</p>
                <h4 className="rsvp-subheader">Gifts</h4>
                <p style={finerTextStyle}>{giftRegistryMsg}</p>
            </div>

            <div className="rsvp-line-break"></div>
        </>
    );
};

export const getInviteWording = (invitedTo) =>
    isAllDayGuest(invitedTo) ? 'wedding' : 'reception';

export default RsvpInvitationDetails;
